<template>
    <div ref="section" class="home-section">
        <div class="home-section__container">
            <!-- <div class="home-section__header">
                <div class="title-wrap">
                    <div class="title-wrap__text">{{ title }}</div>
                    <div class="title-wrap__bg"></div>
                </div>
                <div class="desc-wrap">
                    <div>{{ desc }}</div>
                    <div class="desc-wrap__left-line"></div>
                    <div class="desc-wrap__right-line"></div>
                </div>
            </div> -->
            <div :style="bodyStyle" class="home-section__body">
                <slot></slot>
            </div>
        </div>
        <div class="home-section__footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeSection',
    props: {
        title: {
            type: String,
            default: '',
        },
        desc: {
            type: String,
            default: '',
        },
        bodyStyle: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss" scoped>
.home-section {
    position: relative;
    // margin-top: 120px;
    // height: 100%;
    // background-size: cover;
    // background-position: 50%;
    // background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 2;
    &__container {
        width: 100%;
        margin: 0 auto;
        // transform: scale(0.9167);
    }
    &__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        // margin-top: 16vh;
        .title-wrap {
            color: #fff;
            font-size: 40px;
            font-weight: 600;
            height: 56px;
            line-height: 56px;
            margin: 0;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            &__text {
                z-index: 100;
            }
        }
        .desc-wrap {
            // margin-top: 10px;
            // font-size: 16px;
            font-size: 20px;
            letter-spacing: 2px;
            font-weight: 500;
            // height: 22px;
            // opacity: 0.8;
            color: #7fb1ff;
            position: relative;

            $line-width: 240px;
            $box-width: 10px;
            $line-height: 2px;
            &__left-line,
            &__right-line {
                position: absolute;
                top: 10px;
            }
            &__left-line {
                width: $line-width;
                height: $line-height;
                background: linear-gradient(90deg, rgba(123, 176, 255, 0) 0%, #7bb0ff 100%);
                left: -($line-width + 15px);
                &::after {
                    position: absolute;
                    content: '';
                    height: $box-width;
                    width: $box-width;
                    background: #7bb0ff;
                    transform: rotate(45deg);
                    right: 0;
                    top: -($box-width / 2);
                }
            }
            &__right-line {
                width: $line-width;
                height: $line-height;
                background: linear-gradient(270deg, rgba(123, 176, 255, 0) 0%, #7bb0ff 100%);
                right: -($line-width + 15px);

                &::after {
                    position: absolute;
                    content: '';
                    height: $box-width;
                    width: $box-width;
                    background: #7bb0ff;
                    transform: rotate(45deg);
                    left: 0;
                    top: -($box-width / 2);
                }
            }
        }
    }
    &__body {
        margin-top: 40px;
        // padding: 0 20px;
    }
    &__footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }
}
</style>
